import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "@/i18n/locales/en.json";
import vi from "@/i18n/locales/vi.json";
import de from "@/i18n/locales/de.json";
import fr from "@/i18n/locales/fr.json";
import ru from "@/i18n/locales/ru.json";

export const LANGS = ["en", "vi", "de", "fr", "ru"];
export const LANG_LABELS = { en: "EN", vi: "VI", de: "DE", fr: "FR", ru: "RU" };
export const LANG_NAMES = { en: "English", vi: "Tiếng Việt", de: "Deutsch", fr: "Français", ru: "Русский" };

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    vi: { translation: vi },
    de: { translation: de },
    fr: { translation: fr },
    ru: { translation: ru },
  },
  lng: "en",
  fallbackLng: "en",
  supportedLngs: LANGS,
  interpolation: { escapeValue: false },
  returnObjects: false,
});

export default i18n;
